module.exports = __webpack_public_path__ + "img/edit-hover.91329184.svg";